/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SupplierDto } from './SupplierDto';
import {
    SupplierDtoFromJSON,
    SupplierDtoFromJSONTyped,
    SupplierDtoToJSON,
} from './SupplierDto';

/**
 * 
 * @export
 * @interface SuppliersResponseDto
 */
export interface SuppliersResponseDto {
    /**
     * Array of supplier records
     * @type {Array<SupplierDto>}
     * @memberof SuppliersResponseDto
     */
    data: Array<SupplierDto>;
    /**
     * Number of suppliers returned in current query
     * @type {number}
     * @memberof SuppliersResponseDto
     */
    queryCount: number;
    /**
     * Total number of suppliers matching filters
     * @type {number}
     * @memberof SuppliersResponseDto
     */
    totalCount: number;
    /**
     * Total number of pages available
     * @type {number}
     * @memberof SuppliersResponseDto
     */
    totalPages: number;
}

/**
 * Check if a given object implements the SuppliersResponseDto interface.
 */
export function instanceOfSuppliersResponseDto(value: object): value is SuppliersResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('queryCount' in value) || value['queryCount'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    return true;
}

export function SuppliersResponseDtoFromJSON(json: any): SuppliersResponseDto {
    return SuppliersResponseDtoFromJSONTyped(json, false);
}

export function SuppliersResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuppliersResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(SupplierDtoFromJSON)),
        'queryCount': json['queryCount'],
        'totalCount': json['totalCount'],
        'totalPages': json['totalPages'],
    };
}

export function SuppliersResponseDtoToJSON(value?: SuppliersResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ((value['data'] as Array<any>).map(SupplierDtoToJSON)),
        'queryCount': value['queryCount'],
        'totalCount': value['totalCount'],
        'totalPages': value['totalPages'],
    };
}

